export type EvasionEvidence = {
  blacklistId: string;
  signal: string;
  matchedValue: string;
  blacklistValue: string;
};

/** Transforme les signaux techniques en preuve lisible : identifiant conservé puis changement. */
export function describeEvasionProof(evidence: EvasionEvidence[]) {
  const changed = evidence.find((item) =>
    item.signal === "discord_changed_for_epic" || item.signal === "epic_changed_for_discord");
  if (!changed) return null;
  const discordChanged = changed.signal === "discord_changed_for_epic";
  const changes = evidence.filter((item) => item.signal === changed.signal);
  const sourceIds = new Set(changes.map((item) => String(item.blacklistId)));
  const shared = evidence.find((item) =>
    sourceIds.has(String(item.blacklistId))
    && item.signal === (discordChanged ? "epic_id_exact" : "discord_id_exact"));
  return {
    partageLabel: discordChanged ? "Même Epic ID" : "Même Discord ID",
    partageValeur: shared?.blacklistValue ?? shared?.matchedValue,
    changeLabel: discordChanged ? "Discord changé" : "Epic changé",
    anciens: [...new Set(changes.map((item) => item.blacklistValue))],
    nouveau: changed.matchedValue,
  };
}
